@if (loading.orderHeader) {
  <div id="loadingLNOrderContainer" class="overlay full">
    <p class="text-center">{{ appStrings.loadingLnOrderDetails }}</p>
    <ds-progress-spinner id="LNOrderDetailsLoader"></ds-progress-spinner>
  </div>
}

@if (loading.trackingInformation) {
  <div id="loadingTrackingInfo" class="overlay full">
    <p class="text-center">{{ appStrings.loadingTrackingInfo }}</p>
    <ds-progress-spinner id="trackingInfoLoader"></ds-progress-spinner>
  </div>
}

@if (!importQuoteActive && !isMobile) {
  <div class="header-container">
    <div class="header-title">
      <typography id="quoteTitle" variant="mat-headline-4" weight="bold"> {{ appStrings.label_lnOrderDetails }}</typography>
      <typography id="quoteTitle" variant="mat-headline-4" weight="bold">|</typography>
      <typography id="lnOrderNumberLabel" variant="mat-headline-4" weight="bold">
        {{ appStrings.quoteSearch_orderNumber }} -
      </typography>
      <typography id="lnOrderNumberValue" variant="mat-headline-4" weight="bold">
        {{ lnOrderNumber }}
      </typography>
    </div>
    <div class="header-buttons">
      <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="closeButton" (onClick)="close()"
        [label]="appStrings.button_close">
      </ds-button>
      <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="printButton" (onClick)="printLnOrder(lnOrderNumber)"
        [label]="appStrings.button_print">
      </ds-button>
      <ds-button class="half-width" size="large" type="primary" variant="label-only" id="tracklnOrderButton" (onClick)="trackLnOrder()"
        [label]="appStrings.invoice_trackButton">
      </ds-button>
    </div>
  </div>
}

@if (isMobile && isAccountDetails) {
  <div class="breadcrumb-container">
    <ds-breadcrumbs [breadcrumbs]="breadcrumbs" separatorType="slash" [collapsable]="false" [iconStyle]="isMobile ? 'material-icons-outlined' : null"></ds-breadcrumbs>
  </div>
}

<div id="lnOrderView" [ngClass]="{'view-container-mobile': isMobile}">
  @if (isMobile) {
    <div id="lnOrderViewHeaderlnOrderNumber" class="lnOrder-view-header">
      <typography id="lnOrderNumberLabel" variant="mat-headline-4" weight="bold">
        {{ appStrings.quoteSearch_orderNumber }} -
      </typography>
      <typography id="lnOrderNumberValue" variant="mat-headline-4" weight="bold">
        {{ lnOrderNumber }}
      </typography>
    </div>
  }

  <div class="accordion-container">
    <mat-accordion id="lnOrderContainer">
      <!-- Ln Order Header Panel -->
      <mat-expansion-panel [expanded]="true" id="lnOrderHeaderContainer" #lnOrderHeaderContainer>
        <mat-expansion-panel-header id="lnOrderHeaderExpansionPanel">
          <div id="lnOrderHeaderTitle">
            <h2>{{ appStrings.lnOrder_header }}</h2>
          </div>
        </mat-expansion-panel-header>

        <app-ln-order-header [lnOrderHeaderResult]="lnOrderHeaderDetails"></app-ln-order-header>
      </mat-expansion-panel>

      <!-- Ln Order Details Panel -->
      <mat-expansion-panel id="lnOrderDetailsContainer" #lnOrderDetailsContainer>
        <mat-expansion-panel-header id="lnOrderDetailsExpansionPanel">
          <div id="lnOrderDetailsTitle">
            <h2>{{ appStrings.lnOrder_details }}</h2>
          </div>
        </mat-expansion-panel-header>

        <app-ln-order-details [lnOrderNumber]="lnOrderNumber" [currencySymbol]="lnOrderHeaderDetails?.currencySign">
        </app-ln-order-details>

      </mat-expansion-panel>
    </mat-accordion>
  </div>

  @if (isMobile) {
    <div class="mobile-sticky-footer">
      <div class="custom-header-buttons">
        <div class="custom-header-buttons">
          <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="closeButton" (onClick)="close()"
            [label]="appStrings.button_close">
          </ds-button>
          <ds-button class="quarter-width" size="large" type="secondary" variant="label-only" id="printButton" (onClick)="printLnOrder(lnOrderNumber)"
            [label]="appStrings.button_print">
          </ds-button>
        </div>
        <ds-button class="half-width" size="large" type="primary" variant="label-only" id="tracklnOrderButton" (onClick)="trackLnOrder()"
          [label]="appStrings.invoice_trackButton">
        </ds-button>
      </div>
    </div>
  }
</div>
